import { render, staticRenderFns } from "./statistics_v2.vue?vue&type=template&id=bc86e930&scoped=true&"
import script from "./statistics_v2.vue?vue&type=script&lang=js&"
export * from "./statistics_v2.vue?vue&type=script&lang=js&"
import style0 from "./statistics_v2.vue?vue&type=style&index=0&id=bc86e930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc86e930",
  null
  
)

export default component.exports